/**
 * <strong>Purpose:</strong> <br>
 * Provides the capability to control the tab index on additional nodes in a widget's dom other than the "focusNode".<br>
 *
 * @module mw-form/mixins/property/TabIndexNodesMixin
 *
 * @copyright Copyright 2015-2017 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "mw-form/mixins/property/DisabledMixin"

], function (declare, lang, DisabledMixin) {

    var verifyInputNodes = function (nodes) {
        if (typeof nodes !== "object" || nodes.constructor !== Array) {
            if (nodes.length > 0 && nodes[0].constructor !== HTMLDivElement) {
                throw new Error("'tabIndexNodes' property expects an array of DOM nodes as input.");
            }
        }
    };

    var TabIndexNodesMixin = declare(null, {

        tabIndexNodes: [],

        addTabIndexNodes: function (nodes) {
            verifyInputNodes(nodes);

            this.set("tabIndexNodes", this.get("tabIndexNodes").concat(nodes));
        },

        removeTabIndexNodes: function (nodes) {
            verifyInputNodes(nodes);

            var head, tail, index, tabIndexNodes = this.get("tabIndexNodes");

            nodes.forEach(
                function(node) {
                    index = tabIndexNodes.indexOf(node);

                    if (index === -1) {
                        head = tabIndexNodes;
                        tail = [];
                    } else {
                        head = tabIndexNodes.slice(0, index);
                        tail = tabIndexNodes.slice(index + 1,
                                index + 1 + (tabIndexNodes.length - index));
                    }

                    tabIndexNodes = head.concat(tail);

                    node.removeAttribute("tabIndex");
                }
            );

            this.set("tabIndexNodes", tabIndexNodes);
        },

        // When TabIndex is supported as an API, this method could be updated to support order as well.
        _setTabIndexNodesAttr: function (nodes) {
            verifyInputNodes(nodes);

            this._set("tabIndexNodes",nodes);

            this._updateTabIndices();
        },

        _setDisabledAttr: function (disabled) {
            this.inherited(arguments);
            this._updateTabIndices();
        },

        _updateTabIndices: function () {
            this.get("tabIndexNodes").forEach(
                lang.hitch(this, function (node) {
                    this._setTabIndexOnNode(node);
                })
            );
        }

    });

    TabIndexNodesMixin._dependencies = [
        {mixin: DisabledMixin, orderDependent: true}
    ];

    return TabIndexNodesMixin;
});
